module.exports = {
      id: "374a7a2c3230c740821639c5a5fd6838sewerage-septic.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#374a7a2c3230c740821639c5a5fd6838sewerage-septic.svg",
      toString: function () {
        return this.url;
      }
    }